var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardDataPoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insights_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1295",
    "data-name": "Rectangle 1295",
    width: 27,
    height: 30,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    transform: "translate(1.129 3.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M23.581,8A2.468,2.468,0,0,0,21.4,11.138l-4.008,4.451a2.085,2.085,0,0,0-1.174,0L13.341,12.4a2.467,2.467,0,0,0-2.179-3.15A2.468,2.468,0,0,0,8.983,12.4L3.834,18.089A2.316,2.316,0,0,0,1,20.5,2.4,2.4,0,0,0,3.258,23a2.468,2.468,0,0,0,2.179-3.138l5.137-5.7a2.085,2.085,0,0,0,1.174,0l2.879,3.188a2.467,2.467,0,0,0,2.179,3.15,2.468,2.468,0,0,0,2.179-3.15l4.019-4.438A2.316,2.316,0,0,0,25.84,10.5,2.4,2.4,0,0,0,23.581,8Z",
    transform: "translate(-1 -1.749)",
    fill: "#C4141B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M15.387,10.5l1.061-2.588L18.774,6.75,16.449,5.588,15.387,3,14.348,5.588,12,6.75l2.348,1.163Z",
    transform: "translate(0.42 -3)",
    fill: "#C4141B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M3.823,12.251l.565-2.5,2.258-.625L4.387,8.5,3.823,6,3.258,8.5,1,9.125l2.258.625Z",
    transform: "translate(-1 -2.25)",
    fill: "#C4141B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDataPoints);
export default __webpack_public_path__ + "static/media/dashboard_data_points.8a14fbd3594a906db59a3b34dbbdd307.svg";
export { ForwardRef as ReactComponent };